// import StatAndSort from '@components/Algolia/StatAndSort'
import { InsightsMiddleware } from '@components/algolia'
import AlgoliaHit from '@components/algolia/AlgoliaHit'
import CustomInfiniteHits from '@components/algolia/CustomInfiniteHits'
import NoOfFilters from '@components/algolia/NoOfFilters/NoOfFilters'
import { SliderWithButtons } from '@components/common'
import { ColourAction, Filter, ImageAction } from '@components/icons'
import { ProductCardMode } from '@components/product/ProductCard/ProductCard'
import { useUI } from '@components/ui'
import cn from 'clsx'
import { createInfiniteHitsSessionStorageCache } from 'instantsearch.js/es/lib/infiniteHitsCache'
import { useTranslation } from 'next-i18next'
import singletonRouter from 'next/router'
import { useState } from 'react'
import {
  Configure,
  InstantSearch,
  InstantSearchSSRProvider,
  Stats,
} from 'react-instantsearch'
import { createInstantSearchRouterNext } from 'react-instantsearch-router-nextjs'
import FilterSidebar from '../FilterSidebar'
interface props {
  defaultCategory: string
  searchClient: any
  indexName: string
  filterString: string
  searchTerm?: string
  collectionType?: string
  serverState?: any
  locale?: string
  videoHits?: boolean
}
const AlgoliaCollection = ({
  defaultCategory,
  searchClient,
  indexName,
  filterString,
  searchTerm,
  collectionType,
  serverState,
  locale,
  videoHits = false,
}: props) => {
  const { t } = useTranslation('common')
  const [hitsPerPage] = useState(35)
  const [mode, setMode] = useState<ProductCardMode>(ProductCardMode.COLOUR)
  const setSliderModeColour = () => setMode(ProductCardMode.COLOUR)
  const setSliderModeImage = () => setMode(ProductCardMode.IMAGE)
  const [sliderValue, setSliderValue] = useState(videoHits ? 4 : 3)
  const [mobileSliderValue, setMobileSliderValue] = useState(videoHits ? 3 : 2)
  const { openFilterSidebar, displayFilterSidebar } = useUI()
  const openFilter = () => {
    openFilterSidebar()
  }
  if (!indexName) {
    return null
  }
  const sessionStorageCache = createInfiniteHitsSessionStorageCache()
  const showControls =
    collectionType?.toLowerCase() === 'colour' ||
    collectionType?.toLowerCase() === 'color' ||
    collectionType?.toLowerCase() === 'farbe'
  const resultsCount = () => (
    <Stats
      translations={{
        rootElementText({ nbHits }: any) {
          return `${nbHits.toLocaleString()} ${t('results')}`
        },
      }}
      className="text-body2 font-light"
    />
  )
  const algoliaRouter: any =
    typeof window === 'undefined'
      ? false
      : {
          router: createInstantSearchRouterNext({
            singletonRouter,
            routerOptions: {
              cleanUrlOnDispose: false,
            },
          }),
          stateMapping: {
            stateToRoute(uiState: any) {
              const indexUiState = uiState[indexName]
              return {
                colour: indexUiState?.refinementList?.['named_tags.colour'],
                q: indexUiState?.configure?.query,
              }
            },
            routeToState(routeState: any) {
              return {
                [indexName]: {
                  refinementList: {
                    'named_tags.colour': routeState?.colour,
                  },
                  configure: {
                    query: routeState?.q,
                  },
                },
              }
            },
          },
        }
  return (
    <div className="algolia_collection">
      <InstantSearchSSRProvider {...serverState}>
        <InstantSearch
          indexName={indexName}
          searchClient={searchClient}
          routing={algoliaRouter}
          future={{ preserveSharedStateOnUnmount: false }}
        >
          {typeof window !== 'undefined' && (
            <InsightsMiddleware locale={locale} />
          )}
          <Configure
            hitsPerPage={hitsPerPage}
            filters={filterString}
            ruleContexts={[defaultCategory]}
            distinct
            facetingAfterDistinct
            query={searchTerm}
            facetFilters={collectionType?.toLowerCase() === 'colour'}
          />
          <div className="algolia_collection__product_list">
            <div className="flex flex-col">
              {showControls && (
                <div
                  className={cn(
                    'filter-bar sticky top-9 z-20 bg-white lg:top-6'
                  )}
                >
                  <div className="mt-5 flex border-y lg:mt-10 ">
                    <div className="wrapper flex items-center">
                      <div className="hidden lg:flex">{resultsCount()}</div>
                      <div className="ml-auto mr-auto flex gap-x-[12px] lg:mr-0 lg:gap-x-7">
                        <div>
                          <button
                            className={cn(
                              ` py-4 ${
                                mode === ProductCardMode.COLOUR
                                  ? 'swatch-btn'
                                  : 'btn-switch'
                              }`
                            )}
                            type="button"
                            onClick={setSliderModeColour}
                          >
                            <ColourAction
                            // opacity={mode === ProductCardMode.COLOUR ? 1 : 0.5}
                            />
                          </button>
                          <button
                            className={cn(
                              ` pl-4 ${
                                mode === ProductCardMode.IMAGE
                                  ? 'img-btn'
                                  : 'btn-switch'
                              }`
                            )}
                            type="button"
                            onClick={setSliderModeImage}
                          >
                            <ImageAction
                            // opacity={mode === ProductCardMode.IMAGE ? 1 : 0.5}
                            />
                          </button>
                        </div>
                        <div className="w-px bg-[#e5e7eb]" />
                        <div className="flex lg:hidden">
                          <SliderWithButtons
                            sliderValue={mobileSliderValue}
                            setSliderValue={setMobileSliderValue}
                            mobile={true}
                          />
                        </div>
                        <div className="hidden lg:flex">
                          <SliderWithButtons
                            sliderValue={sliderValue}
                            setSliderValue={setSliderValue}
                          />
                        </div>
                        <div className="w-px bg-[#e5e7eb]" />
                        {showControls && (
                          <div className="z-10 flex cursor-pointer items-center">
                            <div className="flex" onClick={openFilter}>
                              <Filter />
                              <p className="pl-2 text-body1 ">Filter</p>
                              <div className="ml-2 flex items-center justify-center">
                                <NoOfFilters hideIfZero={true} />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showControls && <FilterSidebar />}
              <div className="ml-auto mr-auto flex pt-4 lg:hidden">
                {resultsCount()}
              </div>
              <div
                className={cn(
                  'infiniteHits lg:transition-all lg:duration-500 lg:ease-in-out',
                  { expanded: displayFilterSidebar }
                )}
              >
                <CustomInfiniteHits
                  HitComponent={AlgoliaHit}
                  mode={mode}
                  sessionStorageCache={sessionStorageCache}
                  showLargeItems={
                    collectionType?.toLowerCase() === 'colour' &&
                    sliderValue === 3
                  }
                  sliderValue={sliderValue}
                  mobileSliderValue={mobileSliderValue}
                />
              </div>
            </div>
          </div>
        </InstantSearch>
      </InstantSearchSSRProvider>
      <style jsx>
        {`
          @media (min-width: 1024px) {
            .infiniteHits.expanded {
              margin: 0;
            }
          }
          .btn-switch {
            opacity: 0.25;
          }

          .btn-switch:hover {
            opacity: 0.75;
          }

          .img-btn:active {
            opacity: 1;
          }

          .swatch-btn:active {
            opacity: 1;
          }
        `}
      </style>
    </div>
  )
}

export default AlgoliaCollection
